@let fieldData = field();

<div class="mb-6">
  @if (fieldData.title) {
    <label
      class="block x-font-body-3 mb-2"
      [class.font-extrabold!]="fieldData.isHighlighted"
    >
      {{ fieldData.title }}
      @if (fieldData.helpText) {
        <tui-icon [tuiTooltip]="fieldData.helpText"></tui-icon>
      }
    </label>
  }

  <div class="space-y-3">
    @if (fieldData.comments && fieldData.comments.length > 0) {
      @for (comment of fieldData.comments; track comment.id) {
        <div
          class="p-4 x-white rounded-lg border border-(--x-workflow-border) workflow-comment"
        >
          <div class="flex flex-col justify-between mb-3">
            <span class="x-font-body-2-bold x-text-wf-text1">
              @if (
                typeof comment.createdId === 'object' &&
                comment.createdId !== null
              ) {
                {{ comment.createdId.fullname }}
              } @else {
                Пользователь
              }
            </span>
            <span class="x-font-body-3 x-text-wf-text2">
              {{ comment.createdAt | date: 'dd.MM.yyyy HH:mm' }}
            </span>
          </div>
          <div
            class="x-font-body-2 x-text-wf-title"
            [innerHTML]="comment.text"
          ></div>
        </div>
      }
    } @else {
      <p class="x-font-body-2-bold x-text-wf-text1 p-4 x-white rounded">
        Нет комментариев
      </p>
    }
  </div>
</div>
